module.exports = __webpack_public_path__ + "img/_parked.7100212a.svg";